import {otsBaseApi} from "../../ots-api";
import {EntityIdentifier} from "../../../model/entity";
import {EntityGraphOptions, EntityGraphResponse} from "../../../model/entity-graph";
import {removeUndefined} from "../../../util/util";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["EntityGraph"]});

export const entityApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEntityGraph: builder.query<EntityGraphResponse, {
      entity: EntityIdentifier,
      opts?: EntityGraphOptions
    }>({
      query: (arg) => ({
        url: `/entities/${arg.entity.type}/${arg.entity.id}/graph`,
        method: "GET",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
        params: removeUndefined({
          direction: arg.opts?.direction,
          maxUpDepth: arg.opts?.maxUpDepth,
          maxDownDepth: arg.opts?.maxDownDepth,
          bestDownTree: arg.opts?.bestDownTree,
          format: arg.opts?.format,
        })
      }),
      providesTags: (result, error, arg) => [{type: "EntityGraph", id: `${arg.entity.type}:${arg.entity.id}`}]
    }),
  })
});

export const {
  useGetEntityGraphQuery,
} = entityApi;
